import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { LstorageService } from "./lstorage.service";
import { DomSanitizer } from "@angular/platform-browser";
import { JwtHelperService } from "@auth0/angular-jwt";
import { LoggedUser } from "../core/models/LoggedUser";
import { encryptData } from "./aes.service";
interface CategoryData {
  categoryId?: string;
  Name: string;
  Description?: string;
  isActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
interface subCatModel {
  categoryId?: string;
  subCategoryId?: string;
  Name: string;
  isActive: boolean;
  createdBy?: string;
  createdOn: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
const AUTH_API = "https://adminapi.synctag.com/api/";
@Injectable({
  providedIn: "root",
})
export class DaoService {
  fileUrl: any;
  jwtHelper = new JwtHelperService();
  constructor(
    private http: HttpClient,
    private token: LstorageService,
    private sanitizer: DomSanitizer
  ) {}

  public isgroupdelete = new BehaviorSubject<boolean>(false);
  public isuserdelete = new BehaviorSubject<boolean>(false);
  public isAttributedelete = new BehaviorSubject<boolean>(false);
  public isResponsMappingdelete = new BehaviorSubject<boolean>(false);
  public isApiDelete = new BehaviorSubject<boolean>(false);
  public isSucategorydelete = new BehaviorSubject<boolean>(false);
  public isCategorydelete = new BehaviorSubject<boolean>(false);
  public isUnlock = new BehaviorSubject<boolean>(false);

  private baseUrl = "https://localhost:7182/api/";
  private AnalyticsList = new BehaviorSubject<any[]>([]);
  finalAnalyticsList = this.AnalyticsList.asObservable();
  analyticsList: any;

  //EntityList
  public EntityList = new BehaviorSubject<any[]>([]);
  finalEntityList = this.EntityList.asObservable();

  //CategoryList
  private categoryList = new BehaviorSubject<any[]>([]);
  finalCategoryList = this.categoryList.asObservable();

  //SubCategoryList
  private SubcategoryList = new BehaviorSubject<any[]>([]);
  finalSubCategoryList = this.SubcategoryList.asObservable();

  private SelectedcatgeoryName = new BehaviorSubject<any[]>([]);
  finalSelectedcatgeoryName = this.SelectedcatgeoryName.asObservable();

  categoryName(data) {
    this.SelectedcatgeoryName.next(data);
  }

  //apimanagerRequiredAttribute;
  //Apigroup
  private apiId = new BehaviorSubject<any[]>([]);
  finalApiId = this.apiId.asObservable();

  //Analytics
  defaultAnalyticsList(data) {
    this.AnalyticsList.next(data);
  }

  dynamicAnalyticsList(analytics) {
    this.AnalyticsList.next(this.AnalyticsList.getValue().concat(analytics));
    this.finalAnalyticsList.subscribe(
      (analyticsList) => (this.analyticsList = analyticsList)
    );
  }
  //Entity
  defaultEntityList(data) {
    console.log("this.EntityList add");
    console.log(this.EntityList);
    this.EntityList.next(data);
  }

  dynamicEntityList(Entity) {
    console.log("this.EntityList");
    console.log(this.EntityList);
    this.EntityList.next(this.EntityList.getValue().concat(Entity));
    this.finalEntityList.subscribe((entityList) => (this.EntityList = Entity));
  }

  //Category
  defaultCategoryList(data) {
    this.categoryList.next(data);
  }

  dynamicCategoryList(category) {
    this.categoryList.next(this.categoryList.getValue().concat(category));
    this.finalCategoryList.subscribe(
      (categoryList) => (this.categoryList = category)
    );
  }

  private categoryId = new BehaviorSubject<any[]>([]);
  finalcategoryId = this.categoryId.asObservable();

  defaultCategoryId(data) {
    this.categoryId.next(data);
  }
  categoryDelete(data) {
    this.isCategorydelete.next(data);
  }

  //SubCategory
  defaultSubCategoryList(data) {
    this.SubcategoryList.next(data);
  }

  dynamicSubCategoryList(subCategory) {
    this.SubcategoryList.next(
      this.SubcategoryList.getValue().concat(subCategory)
    );
    this.finalSubCategoryList.subscribe(
      (finalSubCategoryList) => (this.SubcategoryList = subCategory)
    );
  }

  private subcategoryId = new BehaviorSubject<any[]>([]);
  finalsubcategoryId = this.subcategoryId.asObservable();

  defaultsubCategoryId(data) {
    this.subcategoryId.next(data);
  }
  subcategoryDelete(data) {
    this.isSucategorydelete.next(data);
  }

  dynamiceditAnalyticsList(analytics) {
    this.AnalyticsList.subscribe((value) => {
      for (var i = 0; i < value.length; i++) {
        if (value[i].analyticsId === analytics.analyticsId) {
          console.log("matched value");
          value[i] = analytics;
        }
      }
    });
    this.finalAnalyticsList.subscribe(
      (analyticsList) => (this.analyticsList = analyticsList)
    );
  }

  public sendOtp(countryCode, mobileNumber) {
    var phoneNo = {
      country: countryCode,
      phone: mobileNumber,
    };
    return this.http.post("" + this.baseUrl + "/api/Account/SendOTP", phoneNo, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  public verifyOtp(otpObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Account/VerifyOTP",
      otpObject,
      {}
    );
  }

  public apiTest(url) {
    if (url.httpVerb == "Get") {
      console.log("Get is called");
      var finalUrl = url.apiUrl;

      //url builder with parameter
      if (url.parameter.length >= 1 && url.parameter[0].key != "") {
        finalUrl += "?";
        for (let i of url.parameter) {
          if (i.key != "") {
            var keyValue = "" + i.key + "=" + i.value + "";
            finalUrl += "&" + keyValue;
          }
        }
      }

      //url builder with header
      if (url.header.length >= 1 && url.header[0].key != "") {
        var h2 = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        for (let i of url.header) {
          if (i.key != "") {
            h2[i.key] = i.value;
          }
        }

        return this.http.get("" + finalUrl + "", {
          headers: h2,
        });
      } else {
        return this.http.get("" + finalUrl + "", {});
      }
    }

    if (url.httpVerb == "Post") {
      // alert(url.apiUrl);
      console.log("Post Is called");
      var body = url.bodyContent;
      if (url.header.length >= 1 && url.header[0].key != "") {
        var h2 = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        for (let i of url.header) {
          h2[i.key] = i.value;
        }
        return this.http.post("" + url.apiUrl + "", body, {
          headers: h2,
        });
      } else {
        return this.http.post("" + url.apiUrl + "", body, {});
      }
    }
  }

  public getEntity() {
    return this.http.get("" + this.baseUrl + "/api/Entity", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public getEntities() {
    console.log("Enteres get Entities");
    return this.http.get<any>(AUTH_API + `User/GetEntities`);
  }

  // public getCategory() {
  //   console.log("token: " + this.token.getToken());
  //   return this.http.get("" + this.baseUrl + "/api/Category", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  public getCategory() {
    return this.http.get<any>(AUTH_API + `User/GetCategory`);
  }
  public getSubCategory() {
    return this.http.get<any>(AUTH_API + `User/GetSubCategory`);
  }
  // public getSubCategory() {
  //   return this.http.get("" + this.baseUrl + "/api/SubCategory", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }

  public getParentApiResponse(apiId) {
    console.log("addApitoStaging....");
    console.log(apiId);

    //var searchKeywo{

    //   searchText=apiManager.searchText;
    //  }
    //return this.http.post("" + this.baseUrl + "/api/Dashboard/Search?searchText="+searchKeyword+"", apiManager,{
    return this.http.post("" + this.baseUrl + "/api/Dashboard/Search", apiId, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public addApitoStaging(apiManager) {
  //   console.log("addApitoStaging....");
  //   console.log(apiManager);
  //   //var searchKeywo{
  //   //   searchText=apiManager.searchText;
  //   //  }
  //   //return this.http.post("" + this.baseUrl + "/api/Dashboard/Search?searchText="+searchKeyword+"", apiManager,{
  //   return this.http.post(
  //     "" + this.baseUrl + "/api/Dashboard/Search",
  //     apiManager,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }
  addApitoStaging(key: any) {
    debugger;
    console.log("keyValue!!!", key);

    return this.http.post<any>(AUTH_API + `User/Search`, { key });
  }

  // public apiManagerMapping(apiManagerMapping) {
  //   return this.http.post(
  //     "" + this.baseUrl + "/api/Dashboard/Configure",
  //     apiManagerMapping,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  public apiManagerMapping(key: any) {
    debugger;
    console.log("apiManagerMapping!!!", key);

    return this.http.post<any>(AUTH_API + `User/Configure`, { key });
  }

  public addResponseMapping(responseMapping) {
    return this.http.post(
      "" + this.baseUrl + "/api/ApiManager/ResponseMapping",
      responseMapping,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  // public getResponseMappingList(Id) {
  //   return this.http.get(
  //     "" + this.baseUrl + "/api/ApiManager/ResponseMapping/" + Id + "",
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  public getResponseMappingList(key: any) {
    debugger;
    console.log("getResponseMappingList!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetResponseMapping`, { key });
  }
  public getResponseMappingById(key: any) {
    debugger;
    console.log("getResponseMappingList!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetResponseMappingById`, {
      key,
    });
  }
  // public getResponseMappingById(Id) {
  //   return this.http.get(
  //     "" + this.baseUrl + "/api/ApiManager/ResponseMappingById/" + Id + "",
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  //Api Manager Crud
  public getApiManagerList() {
    return this.http.get("" + this.baseUrl + "/api/ApiManager", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public getApimanagerById(Id) {
  //   return this.http.get("" + this.baseUrl + "/api/ApiManager/" + Id + "", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  getApimanagerById(key: any) {
    debugger;
    console.log("getApimanagerById!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetApimanagerById`, { key });
  }

  // public deleteApimanagerById(id) {
  //   return this.http.delete("" + this.baseUrl + "/api/ApiManager/" + id + "", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  deleteApimanagerById(key: any) {
    debugger;
    console.log("deleteApimanagerById!!!", key);

    return this.http.put<any>(AUTH_API + `User/DeleteApimanagerById`, { key });
  }

  public deleteResponseMappingById(id) {
    return this.http.delete(
      "" + this.baseUrl + "/api/ApiManager/ResponseMapping/" + id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  // public getParentAttribute(ApiId) {
  //   return this.http.get(
  //     "" + this.baseUrl + "/api/ApiManager/MappingAttribue/" + ApiId + "",
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }
  getParentAttribute(key: any) {
    debugger;
    console.log("getParentAttribute!!!", key);

    return this.http.post<any>(AUTH_API + `User/MappingAttribute`, { key });
  }

  public getParentResponse(ApiId) {
    return this.http.get(
      "" + this.baseUrl + "/api/Dashboard/?apiId=" + ApiId + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  //Api Group begin
  changeId(id: any) {
    this.apiId.next(id);
  }

  //Api group
  private ApiGroupList = new BehaviorSubject<any[]>([]);
  finalApiGroupList = this.ApiGroupList.asObservable();
  defaultGroupList(data) {
    this.ApiGroupList.next(data);
  }

  private apigroupId = new BehaviorSubject<any[]>([]);
  finalapiId = this.apigroupId.asObservable();

  defaultApigroupId(data) {
    this.apigroupId.next(data);
  }
  groupDelete(data) {
    this.isgroupdelete.next(data);
  }
  //

  //Response Mapping
  private responsemappingList = new BehaviorSubject<any[]>([]);
  finalresponsemappingList = this.responsemappingList.asObservable();
  defaultResponseMappingList(data) {
    this.responsemappingList.next(data);
  }

  private responseMappingId = new BehaviorSubject<any[]>([]);
  finalresponseMappingId = this.responseMappingId.asObservable();

  defaultresponseMappingId(data) {
    this.responseMappingId.next(data);
  }
  responseMappingDelete(data) {
    this.isResponsMappingdelete.next(data);
  }
  //

  //ApiDelete
  private ApiNode = new BehaviorSubject<any[]>([]);
  finalApiNode = this.ApiNode.asObservable();

  Apiid(data) {
    this.ApiNode.next(data);
  }
  ApiDelete(data) {
    this.isApiDelete.next(data);
  }
  //

  //Attribute
  private attributeList = new BehaviorSubject<any[]>([]);
  finalattributeList = this.attributeList.asObservable();
  defaultAttributeList(data) {
    this.attributeList.next(data);
  }

  private atttributeId = new BehaviorSubject<any[]>([]);
  finalattributeId = this.atttributeId.asObservable();

  defaultAttributeId(data) {
    this.atttributeId.next(data);
  }
  attributeDelete(data) {
    this.isAttributedelete.next(data);
  }
  //

  //Unlock user
  unlockUser(data) {
    this.isUnlock.next(data);
  }

  // public getGroupList() {
  //   return this.http.get("" + this.baseUrl + "/api/Group", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  // getGroupList(key: string) {
  //   debugger;
  //   return this.http.post(AUTH_API + "User/GetGroups", {
  //     key,
  //   });
  // }
  getGroupList() {
    return this.http.get<any>(AUTH_API + `User/GetGroups`);
  }
  public addGroup(group) {
    return this.http.post("" + this.baseUrl + "/api/Group", group, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public getGroup(Id) {
  //   return this.http.get("" + this.baseUrl + "/api/Group/" + Id + "", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  getApiGroupById(key: any) {
    debugger;
    console.log("keyValue!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetApiGroupById`, { key });
  }
  getGroupById(key: any) {
    debugger;
    console.log("keyValue!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetGroupById`, { key });
  }
  saveGroup(key: any) {
    debugger;
    console.log("Save", key);
    console.log("saveGroup!!!", key);

    return this.http.post<any>(AUTH_API + `User/SaveGroup`, { key });
  }
  saveApiGroup(key: any) {
    debugger;
    console.log("saveApiGroup!!!", key);

    return this.http.post<any>(AUTH_API + `User/saveApiGroup`, { key });
  }
  public addApiGroup(group) {
    return this.http.post(
      "" + this.baseUrl + "/api/Group/AddorUpdateApiGroup",
      group,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public deleteGroupById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Group/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public getApiGroup(id) {
    return this.http.get(
      "" + this.baseUrl + "/api/Group/GetApiGroupById" + id + "",
      {
        headers: {
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  //Api Group End

  //Attribute Crud
  // public AddAttribute(attributeObject) {
  //   return this.http.post(
  //     "" + this.baseUrl + "/api/Attribute",
  //     attributeObject,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  public getAttributeList() {
    return this.http.get("" + this.baseUrl + "/api/Attribute", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public getAttributeById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Attribute/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public getAttributeByEntity(EntityName) {
  //   return this.http.get(
  //     "" +
  //       this.baseUrl +
  //       "/api/Attribute/GetAttributeByEntityId?name=" +
  //       EntityName +
  //       "",
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         Authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  public deleteAttributeById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Attribute/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  //============================================================

  // Entity Crud
  // public AddEntity(entityObject) {
  //   return this.http.post("" + this.baseUrl + "/api/Entity", entityObject, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }

  AddEntity(key: any) {
    debugger;
    console.log("Entered addEntity2");
    return this.http.post<any>(AUTH_API + `User/SaveEntity`, { key });
  }
  public getEntityList() {
    return this.http.get("" + this.baseUrl + "/api/Entity", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public getEntityById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Entity/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public deleteEntityById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Entity/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // Category Crud

  // public AddCategory(categoryObject) {
  //   return this.http.post("" + this.baseUrl + "/api/Category", categoryObject, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }

  AddCategory(categoryData: CategoryData) {
    debugger;
    console.log("SaveCategory2!!!", categoryData);
    return this.http.post<any>(AUTH_API + `User/SaveCategory`, categoryData);
  }
  // AddCategory(categoryData: any) {
  //   console.log("Saving Category:", categoryData);
  //   return this.http.post<any>(AUTH_API + `User/SaveCategory`, categoryData);
  // }
  // public getCategoryList() {
  //   return this.http.get("" + this.baseUrl + "/api/User", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       authorization: "Bearer " + this.token.getToken() + "",
  //     },
  //   });
  // }
  public getCategoryById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Category/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public deleteCategoryById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Category/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // Subcategory Crud

  // public AddSubcategory(subcategoryObject) {
  //   return this.http.post(
  //     "" + this.baseUrl + "/api/Subcategory",
  //     subcategoryObject,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }

  AddSubcategory(subcategoryObject: any) {
    console.log("Saving SubCategory:", subcategoryObject);
    return this.http.post<any>(
      AUTH_API + `User/SaveSubCategory`,
      subcategoryObject
    );
  }

  public getSubcategoryList() {
    return this.http.get("" + this.baseUrl + "/api/Subcategory", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public getSubCategoryByCatId(catId) {
  //   return this.http.get(
  //     "" + this.baseUrl + "/api/SubCategory/ByCatId/" + catId + "",
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "*/*",
  //         authorization: "Bearer " + this.token.getToken() + "",
  //       },
  //     }
  //   );
  // }
  getSubCategoryByCatId(key: any) {
    debugger;
    console.log("Entered getSubCategoryByCatId");
    return this.http.post<any>(AUTH_API + `User/GetSubCategoryByGuidCatId`, {
      key,
    });
  }
  getSubCategoryByGuidCatId(key: any) {
    debugger;
    console.log("Entered GetSubCategoryByGuidCatId");
    return this.http.post<any>(AUTH_API + `User/GetSubCategoryByGuidCatId`, {
      key,
    });
  }

  public getSubcategoryById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Subcategory/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public deleteSubcategoryById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Subcategory/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // public uploadSubCategoryLogo(subcategoryObject, logo) {
  //   console.log(subcategoryObject, logo);
  //   var subcatId;
  //   if (subcategoryObject.subCategoryId != undefined) {
  //     subcatId = subcategoryObject.subCategoryId;
  //   } else {
  //     subcatId = "";
  //   }
  //   let user = this.loggedUser.UserUniqueId;
  //   return this.http.post(
  //     "" +
  //       this.baseUrl +
  //       "/api/SubCategory/UploadLogo?categoryName=" +
  //       subcategoryObject.categoryId +
  //       "&subcategoryName=" +
  //       subcategoryObject.name +
  //       "&userName=" +
  //       user +
  //       "&subcategoryId=" +
  //       // subcategoryObject.createdBy +
  //       // "&subcategoryId=" +
  //       subcatId +
  //       "",
  //     logo,
  //     {
  //       headers: new HttpHeaders({
  //         Accept: "*/*",
  //         authorization: "Bearer " + this.token.getToken() + "",
  //       }),
  //     }
  //   );
  // }
  // uploadSubCategoryLogo(subcategoryObject: subCatModel) {
  //   console.log("Saving SubCategory:", subcategoryObject);
  //   return this.http.post<any>(
  //     AUTH_API + `User/SaveSubCategory`,
  //     subcategoryObject
  //   );
  // }

  uploadSubCategoryLogo(subCategoryData: subCatModel) {
    debugger;
    console.log("Saving SubCategory:", subCategoryData);
    return this.http.post<any>(
      AUTH_API + `User/SaveSubCategory`,
      subCategoryData
    );
  }
  //    // User curd
  //    public AddUser(userObject) {
  //        return this.http.post('' + this.baseUrl + '/api/Account/Create', userObject, {
  //            headers: {
  //                'Content-Type': 'application/json',
  //                Accept: '*/*',
  //                authorization: 'Bearer ' + this.token.getToken() + ''
  //            }
  //        });
  //    }
  //    public getUserList() {
  //        return this.http.get('' + this.baseUrl + '/api/Account/', {
  //            headers: {
  //                'Content-Type': 'application/json',
  //                Accept: '*/*',
  //                authorization: 'Bearer' + this.token.getToken() + ''
  //            }
  //        });
  //    }
  //
  //    public getUserById(Id) {
  //        return this.http.get('' + this.baseUrl + '/api/Account/' + Id + '', {
  //            headers: {
  //                'Content-Type': 'application/json',
  //                Accept: '*/*',
  //                authorization: 'Bearer' + this.token.getToken() + ''
  //            }
  //        });
  //    }
  //
  //    public deleteUserById(Id) {
  //        return this.http.delete('' + this.baseUrl + '/api/Account/' + Id + '', {
  //            headers: {
  //                'Content-Type': 'application/json',
  //            Accept: '*/*',
  //                authorization: 'Bearer' + this.token.getToken() + ''
  //            }
  //        });
  //    }

  // user crud
  private UserList = new BehaviorSubject<any[]>([]);
  finalUserList = this.UserList.asObservable();
  userList: any;

  private UserconfigList = new BehaviorSubject<any[]>([]);
  finalUserconfigList = this.UserconfigList.asObservable();
  userconfigList: any;

  // user id
  private UserId = new BehaviorSubject(null);
  fuserId = this.UserId.asObservable();
  private UseractivityId = new BehaviorSubject(null);
  fuseractivityId = this.UseractivityId.asObservable();

  public getUser() {
    return this.http.get("" + this.baseUrl + "/api/Account", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // user edit
  dynamicUserList(user) {
    this.UserList.next(this.UserList.getValue().concat(user));
    this.finalUserList.subscribe((userList) => (this.userList = userList));
  }

  dynamiceditUserList(user) {
    this.UserList.subscribe((value) => {
      for (let i = 0; i < value.length; i++) {
        if (value[i].userId === user.userId) {
          console.log("matched value");
          value[i] = user;
        }
      }
    });
    this.finalUserList.subscribe((userList) => (this.userList = userList));
  }

  defaultUserList(data) {
    this.UserList.next(data);
  }

  dynamiclockUserList(user) {
    this.UserList.subscribe((value) => {
      for (let i = 0; i < value.length; i++) {
        if (value[i].userId === user.userId) {
          console.log("matched value");
          value[i] = user;
        }
      }
    });

    this.finalUserList.subscribe((userList) => (this.userList = userList));
  }

  // API url
  public AddUser(userObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Account/Create",
      userObject,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }
  public getUserList() {
    return this.http.get("" + this.baseUrl + "/api/Account/", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  changeUserId(id) {
    this.UserId.next(id);
  }

  userDelete(data) {
    this.isuserdelete.next(data);
  }

  public getUserById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Account/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public deleteUserById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Account/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public lockUser(userObject) {
    return this.http.post("" + this.baseUrl + "/api/Account/Lock", userObject, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  // userconfig
  public AddUserconfig(userconfigObject) {
    console.log(userconfigObject);

    return this.http.post(
      "" + this.baseUrl + "/api/Account/AddUserConfig",
      userconfigObject,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getUserconfigById(Id) {
    return this.http.get(
      "" + this.baseUrl + "/api/Account/GetUserConfigById?userId=" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  // useractivity
  changeUseractivityId(id) {
    this.UseractivityId.next(id);
  }

  public AddUseractivity(useractivityObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Account/AddUserActivity",
      useractivityObject,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getUseractivityById(Id) {
    return this.http.get(
      "" + this.baseUrl + "/api/Account/GetuserActivityById?userId=" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  // Analytics curd
  public AddAnalytics(analyticsObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Analytics",
      analyticsObject,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }
  public getAnalyticsList() {
    var skp = 0;
    var lmt = 100;
    var col = "Name";
    var srt = true;

    return this.http.get(
      "" +
        this.baseUrl +
        "/api/Analytics/?PaginationID=" +
        skp +
        "&Count=" +
        lmt +
        "&CoulumnName=" +
        col +
        "&SortType=" +
        srt +
        "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getLogo(analyticsId) {
    return this.http.get(
      "" + this.baseUrl + "/api/Analytics/View/" + analyticsId + "",
      {
        headers: {
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
        responseType: "blob",
      }
    );
  }

  public getAnalyticsById(Id) {
    return this.http.get("" + this.baseUrl + "/api/Analytics/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public deleteAnalyticsById(Id) {
    return this.http.delete("" + this.baseUrl + "/api/Analytics/" + Id + "", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        authorization: "Bearer " + this.token.getToken() + "",
      },
    });
  }

  public uploadAnalyticsLogo(logo, id) {
    return this.http.post(
      "" + this.baseUrl + "/api/Analytics/UploadLogo?AnalyticsId=" + id + "",
      logo,
      {
        headers: new HttpHeaders({
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        }),
      }
    );
  }

  // Repository crud

  public onView(fileId) {
    return this.http.get(
      this.baseUrl + "/api/Repository/View/OcrData/" + fileId + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
        responseType: "blob",
      }
    );
  }

  public fileView(userId, folderName) {
    return this.http.get(
      "" +
        this.baseUrl +
        "/api/Repository/ViewUploadedFiles?userId=" +
        userId +
        "&folderName=" +
        folderName +
        "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public AddRepository(template) {
    return this.http.get(
      "" +
        this.baseUrl +
        "/api/Repository/FolderSave?userId=" +
        template.userId +
        "&folderName=" +
        template.folderName +
        "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getRepositoryById(Id) {
    return this.http.get(
      "" + this.baseUrl + "/api/Repository/FolderView?userId=" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getRepositoryByUserId(Id) {
    return this.http.get(
      "" +
        this.baseUrl +
        "/api/Repository/FolderViewByUserId?userId=" +
        Id +
        "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public deleteRepositoryById(Id) {
    return this.http.delete(
      "" + this.baseUrl + "/api/Repository/FolderDelete" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public Uploadfile(template, file) {
    return this.http.post(
      "" +
        this.baseUrl +
        "/api/Repository/Upload?userId=" +
        template.userId +
        "&folderName=" +
        template.folderName +
        "",
      file,
      {
        headers: new HttpHeaders({
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        }),
      }
    );
  }

  public getViewUploadedFilesById(viewUploadedFilesObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Repository/ViewUploadedFiles?userId=",
      viewUploadedFilesObject.userId +
        "&folderName=" +
        viewUploadedFilesObject.folderName +
        "",
      {
        headers: {
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public SaveABBYYOCRById(SaveABBYYOCRObject) {
    return this.http.post(
      "" + this.baseUrl + "/api/Repository/SaveABBYYOCR?userId=",
      SaveABBYYOCRObject.userId +
        "&folderName=" +
        SaveABBYYOCRObject.folderName +
        "",
      {
        headers: {
          Accept: "*/*",
          authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public addParentResponse(ParentResponse) {
    return this.http.post(
      "" + this.baseUrl + "/api/ApiManager/AddParentMapping",
      ParentResponse,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getParentResponseMappingList(Id) {
    return this.http.get(
      "" + this.baseUrl + "/api/ApiManager/ParentResponseMapping/" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  //Api Pagination
  public addApiPagination(pagination) {
    console.log("Pagination");
    console.log(pagination);
    return this.http.post(
      "" + this.baseUrl + "/api/ApiManager/apiPagination",
      pagination,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }

  public getApiPagination(Id) {
    return this.http.get(
      "" + this.baseUrl + "/api/ApiManager/GetApiPagination/" + Id + "",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: "Bearer " + this.token.getToken() + "",
        },
      }
    );
  }
  public SendOTP(key: string) {
    debugger;
    return this.http.post(AUTH_API + "User/SendVerificationCode", {
      key,
    });
  }
  public VerifyOTP(key: string) {
    debugger;
    return this.http.post(AUTH_API + "User/VerifyCode", {
      key,
    });
  }
  setAuthRoles(loggedUser: LoggedUser): void {
    debugger;
    switch (loggedUser.RoleId) {
      case 1:
        loggedUser.IsSuperAdmin = true;
        break;
      case 2:
        loggedUser.IsAdmin = true;
        break;
      case 3:
        loggedUser.IsUser = true;
        break;
      default:
    }
  }
  get loggedUser(): LoggedUser {
    let user = JSON.parse(localStorage.getItem("currentUser")!) as LoggedUser;
    this.setAuthRoles(user);
    return user;
  }
  decodeJWT(token: string) {
    debugger;
    localStorage.setItem("token", token);
    let decodedToken = this.jwtHelper.decodeToken(token);
    let loggedUser = new LoggedUser();
    loggedUser.Name =
      decodedToken[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
      ];
    loggedUser.Email =
      decodedToken[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
      ];
    loggedUser.Mobile =
      decodedToken[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone"
      ];
    loggedUser.RoleId = parseInt(
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ]
    );
    loggedUser.RoleName = decodedToken["RoleName"];
    loggedUser.UserUniqueId = decodedToken["UserUniqueId"];
    loggedUser.Id = parseInt(decodedToken["Id"]);
    loggedUser.IsActive = decodedToken["IsActive"];
    this.setAuthRoles(loggedUser);
    localStorage.setItem("currentUser", JSON.stringify(loggedUser));
  }
  getAttributeByEntity(key: any) {
    debugger;
    console.log("getAttributeByEntity!!!", key);
    return this.http.post<any>(AUTH_API + `User/GetAttributeByEntity`, { key });
  }
  AddAttribute(key: any) {
    debugger;
    console.log("SaveAttribute!!!", key);
    return this.http.post<any>(AUTH_API + `User/SaveAttribute`, { key });
  }
  getApiRequestById(key: any) {
    debugger;
    console.log("keyValue!!!", key);

    return this.http.post<any>(AUTH_API + `User/GetRequestByGroupId`, { key });
  }
  openAIJsonConvertion(key: any) {
    debugger;
    console.log("openAIJsonConvertion!!!", key);

    return this.http.post<any>(AUTH_API + `User/OpenAIJsonConvertion`, { key });
  }
}
